<script>
import Layout from "../../../layouts/main";
import Multiselect from "vue-multiselect";
import PerPage from "../../../../components/per-page.vue";
import Filters from "../../../../components/filters.vue";
import moment from "moment";
import {
  FETCH_NTUC_UPLOADS,
  FETCH_NTUC_UPLOAD_DETAIL,
  UPLOAD_NTUC_FILES,
  FETCH_NTUC_DATA_SOURCES,
} from "@/state/actions.type";

export default {
  components: {
    Layout,
    Multiselect,
    PerPage,
    Filters,
  },
  data() {
    return {
      currentPage: 1,
      perPage: 10,
      fromDate: "",
      toDate: "",
      selectedDataSourceFilter: [],
      selectedStatusFilter: [],
      statusOptions: [
        { key: "FILE_UPLOAD_INITIATED", text: "Queued" },
        { key: "FILE_UPLOAD_PROCESSING", text: "Processing" },
        { key: "FILE_UPLOAD_VALIDATION_SUCCESS", text: "Validated" },
        { key: "FILE_UPLOAD_VALIDATION_FAIL", text: "Validation Failed" },
        { key: "FILE_UPLOAD_INGESTION_FAIL", text: "Ingestion Failed" },
      ],
      sorting_data: {
        sort_by_key: "",
        order: "",
      },
      showDrawer: false,
      drawerDataSource: null,
      queuedFiles: [],
      isUploading: false,
      uploadResults: [],
      pollingTimers: [],
      showDetailDrawer: false,
      detailItem: null,
      isLoadingDetail: false,
      fields: [
        { key: "CreatedAt", sortable: true, label: "Upload Date" },
        { key: "file_name", sortable: false, label: "File Name" },
        { key: "display_name", sortable: false, label: "Data Source" },
        { key: "records", sortable: false, label: "Records" },
        { key: "status", sortable: false, label: "Status" },
        { key: "actions", label: "", stickyColumn: true },
      ],
    };
  },

  filters: {
    date(value) {
      return moment(value).format("DD MMM YYYY");
    },
    time(value) {
      return "at " + moment(value).format("hh:mm A");
    },
    datetime(value) {
      if (!value) return "\u2014";
      return moment(value).format("DD MMM YYYY, hh:mm A");
    },
  },

  computed: {
    uploads() {
      return this.$store.state.ntucRecon.uploads;
    },
    totalRows() {
      return this.$store.state.ntucRecon.uploadTotal;
    },
    isFetching() {
      return this.$store.state.ntucRecon.isFetchingUploads;
    },
    dataSources() {
      return this.$store.state.ntucRecon.dataSources;
    },
  },

  created() {
    this.fetchUploads();
    this.$store.dispatch(`ntucRecon/${FETCH_NTUC_DATA_SOURCES}`);
  },

  beforeDestroy() {
    this.clearAllPolling();
  },

  methods: {
    fetchUploads() {
      let filters = {
        data_source: ["ntuc_athena_report", "ntuc_dbs_advice", "ntuc_ob_report", "ntuc_gb_report"],
        status: [],
      };

      if (this.selectedDataSourceFilter.length > 0) {
        filters.data_source = this.selectedDataSourceFilter.map((ds) => ds.key);
      }

      if (this.selectedStatusFilter.length > 0) {
        filters.status = this.selectedStatusFilter.map((s) => s.key);
      }

      let payload = {
        page: this.currentPage,
        pagesize: this.perPage,
        filters: filters,
        sorting_data: this.sorting_data,
      };

      if (this.fromDate) {
        payload.from_date = moment(this.fromDate, "DD-MM-YYYY HH:mm").format("YYYY-MM-DDTHH:mm:ssZ");
      }

      if (this.toDate) {
        payload.to_date = moment(this.toDate, "DD-MM-YYYY HH:mm").format("YYYY-MM-DDTHH:mm:ssZ");
      } else {
        payload.to_date = moment().format("YYYY-MM-DDTHH:mm:ssZ");
      }

      this.$store.dispatch(`ntucRecon/${FETCH_NTUC_UPLOADS}`, payload);
    },

    dateChanged(value) {
      this.fromDate = value[0];
      this.toDate = value[1];
      this.fetchUploads();
    },

    toggleFilter() {
      this.$root.$emit("bv::toggle::collapse", "upload-filter-collapse");
    },

    resetAdvanceFilters() {
      this.selectedDataSourceFilter = [];
      this.selectedStatusFilter = [];
    },

    onPerPageChange() {
      this.currentPage = 1;
      this.fetchUploads();
    },

    sortTransactions(item) {
      this.sorting_data.sort_by_key = item.sortBy;
      if (item.sortDesc) {
        this.sorting_data.order = "DESC";
      } else {
        this.sorting_data.order = "ASC";
      }
      this.fetchUploads();
    },

    formatRecords(item) {
      if (item.status === "FILE_UPLOAD_VALIDATION_FAIL" || item.status === "FILE_UPLOAD_INGESTION_FAIL" || item.status === "FILE_UPLOAD_INITIATED" || item.status === "FILE_UPLOAD_PROCESSING") {
        return null;
      }
      if (item.total_records === 0 && item.total_success_records === 0 && item.total_failed_records === 0) {
        return null;
      }
      return `${item.total_records} / ${item.total_success_records} / ${item.total_failed_records}`;
    },

    statusText(status) {
      switch (status) {
        case "FILE_UPLOAD_VALIDATION_SUCCESS":
          return "Validated";
        case "FILE_UPLOAD_VALIDATION_FAIL":
        case "FILE_UPLOAD_INGESTION_FAIL":
          return "Rejected";
        case "FILE_UPLOAD_INITIATED":
          return "Queued";
        case "FILE_UPLOAD_PROCESSING":
          return "Processing";
        default:
          return status;
      }
    },

    openDrawer() {
      this.showDrawer = true;
      this.drawerDataSource = null;
      this.queuedFiles = [];
      this.uploadResults = [];
    },

    closeDrawer() {
      this.showDrawer = false;
      this.drawerDataSource = null;
      this.queuedFiles = [];
      this.uploadResults = [];
    },

    onFilePicked(event) {
      const files = Array.from(event.target.files);
      files.forEach((f) => this.queuedFiles.push(f));
      event.target.value = "";
    },

    onDrop(event) {
      const files = Array.from(event.dataTransfer.files);
      files.forEach((f) => this.queuedFiles.push(f));
    },

    removeFile(index) {
      this.queuedFiles.splice(index, 1);
    },

    formatFileSize(bytes) {
      if (bytes === 0) return "0 Bytes";
      const k = 1000;
      const sizes = ["Bytes", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    async submitUpload() {
      if (!this.drawerDataSource || this.queuedFiles.length === 0) {
        this.$notify({
          type: "error",
          text: "Please select a data source and at least one file.",
          closeOnClick: true,
        });
        return;
      }

      this.isUploading = true;
      this.uploadResults = [];
      const formData = new FormData();
      formData.append("data_source", this.drawerDataSource.key);
      formData.append("environment", this.$store.getters["auth/getCurrentEnvironment"]);

      for (const file of this.queuedFiles) {
        formData.append("files[]", file);
      }

      try {
        const response = await this.$store.dispatch(`ntucRecon/${UPLOAD_NTUC_FILES}`, formData);

        if (response.files) {
          this.uploadResults = response.files;
          const accepted = response.files.filter((f) => f.status === "FILE_UPLOAD_INITIATED");
          const rejected = response.files.filter((f) => f.status === "REJECTED");

          if (accepted.length > 0) {
            this.$notify({
              type: "success",
              text: `${accepted.length} file(s) uploaded successfully.`,
              closeOnClick: true,
            });
            this.fetchUploads();
            accepted.forEach((file) => this.pollUploadStatus(file.ref));
          }

          if (rejected.length > 0) {
            this.$notify({
              type: "error",
              text: `${rejected.length} file(s) rejected.`,
              closeOnClick: true,
            });
          }

          if (accepted.length > 0 && rejected.length === 0) {
            this.closeDrawer();
          }
        }
      } catch (error) {
        console.error("Upload failed:", error);
      } finally {
        this.isUploading = false;
      }
    },

    pollUploadStatus(ref) {
      let attempts = 0;
      const maxAttempts = 60;
      const timer = setInterval(async () => {
        attempts++;
        if (attempts > maxAttempts) {
          clearInterval(timer);
          this.pollingTimers = this.pollingTimers.filter((t) => t !== timer);
          this.fetchUploads();
          return;
        }
        try {
          const response = await this.$store.dispatch(`ntucRecon/${FETCH_NTUC_UPLOAD_DETAIL}`, ref);
          const record = (response && response.data && response.data.data) || (response && response.data) || response || {};
          if (record.status && record.status !== "FILE_UPLOAD_INITIATED" && record.status !== "FILE_UPLOAD_PROCESSING") {
            clearInterval(timer);
            this.pollingTimers = this.pollingTimers.filter((t) => t !== timer);
            this.fetchUploads();
          }
        } catch (error) {
          clearInterval(timer);
          this.pollingTimers = this.pollingTimers.filter((t) => t !== timer);
          this.fetchUploads();
        }
      }, 5000);
      this.pollingTimers.push(timer);
    },

    clearAllPolling() {
      this.pollingTimers.forEach((timer) => clearInterval(timer));
      this.pollingTimers = [];
    },

    async openDetail(item) {
      this.detailItem = item;
      this.showDetailDrawer = true;
      this.isLoadingDetail = true;
      try {
        const response = await this.$store.dispatch(`ntucRecon/${FETCH_NTUC_UPLOAD_DETAIL}`, item.ref);
        const record = (response && response.data && response.data.data) || (response && response.data) || response || {};
        this.detailItem = { ...item, ...record };
      } catch (error) {
        console.error("Failed to fetch upload detail:", error);
      } finally {
        this.isLoadingDetail = false;
      }
    },

    closeDetail() {
      this.showDetailDrawer = false;
      this.detailItem = null;
    },

    downloadFile(item) {
      if (item.file_path) {
        window.open(item.file_path, "_blank");
      }
    },
  },
};
</script>

<template>
  <Layout>
    <filters class="mb-3" @date-change="dateChanged" @toggle-filter="toggleFilter" :hideFilter="false" />

    <b-collapse id="upload-filter-collapse" accordion="ntuc-upload-accordion" style="padding: 25px;" class="common-border bg-white mb-3">
      <div class="mb-4">
        <label>Data Source</label>
        <multiselect
          v-model="selectedDataSourceFilter"
          :options="dataSources"
          :multiple="true"
          label="display_name"
          track-by="key"
          placeholder="Search Data Source"
          :searchable="true"
          :close-on-select="false"
        />
      </div>

      <div class="mb-4">
        <label>Validation Status</label>
        <multiselect
          v-model="selectedStatusFilter"
          :options="statusOptions"
          :multiple="true"
          label="text"
          track-by="key"
          placeholder="Search Status"
          :searchable="true"
          :close-on-select="false"
        />
      </div>

      <div class="d-flex justify-content-between">
        <b-btn variant="link" @click="resetAdvanceFilters" class="text-chai font-16px">Clear Filters</b-btn>
        <div>
          <b-btn variant="white" @click="toggleFilter" class="mr-2 cancel">Cancel</b-btn>
          <b-btn variant="primary" @click="fetchUploads(); toggleFilter();" class="btn-padding">Apply</b-btn>
        </div>
      </div>
    </b-collapse>

    <div v-if="selectedDataSourceFilter.length > 0 || selectedStatusFilter.length > 0" class="d-flex flex-wrap mb-3" style="gap: 8px;">
      <div
        v-for="(ds, index) in selectedDataSourceFilter"
        :key="'ds-' + index"
        class="badge custom-status badge-soft-warning d-flex align-items-center"
        style="font-size: 13px; padding: 6px 10px; gap: 6px;"
      >
        {{ ds.display_name }}
        <i class="mdi mdi-close cursor-pointer" @click="selectedDataSourceFilter.splice(index, 1); fetchUploads();"></i>
      </div>
      <div
        v-for="(st, index) in selectedStatusFilter"
        :key="'st-' + index"
        class="badge custom-status badge-soft-warning d-flex align-items-center"
        style="font-size: 13px; padding: 6px 10px; gap: 6px;"
      >
        {{ st.text }}
        <i class="mdi mdi-close cursor-pointer" @click="selectedStatusFilter.splice(index, 1); fetchUploads();"></i>
      </div>
      <b-btn variant="link" class="text-chai p-0" style="font-size: 13px;" @click="resetAdvanceFilters(); fetchUploads();">Clear all</b-btn>
    </div>

    <div class="d-flex justify-content-between my-3">
      <div></div>
      <div class="d-flex" style="gap: 10px;">
        <router-link to="/reconciliation/ntuc/reports" class="btn btn-white" style="height: 44px; border-radius: 12px; border: 1px solid #DCDAD5; padding: 13px 16px; font-size: 14px;">
          View Reports
        </router-link>
        <b-btn variant="primary" @click="openDrawer" style="height: 44px;" class="btn-padding">
          <i class="mdi mdi-upload mr-1"></i> Upload Files
        </b-btn>
      </div>
    </div>

    <b-table
      class="table-custom"
      :items="uploads"
      :fields="fields"
      responsive="sm"
      sticky-header="50vh"
      show-empty
      :busy="isFetching"
      empty-text="No uploads found"
      hover
      no-local-sorting
      @sort-changed="sortTransactions"
    >
      <template v-slot:head()="data">
        <span>
          {{ $t(data.label) }}
          <img v-show="data.field.sortable && sorting_data.sort_by_key !== data.column" class="ml-2" src="@/assets/images/arrow-3.svg" alt="sort_up">
          <img v-show="data.field.sortable && sorting_data.sort_by_key === data.column && sorting_data.order === 'ASC'" class="ml-2" src="@/assets/images/sort_asc.svg" alt="sort_asc">
          <img v-show="data.field.sortable && sorting_data.sort_by_key === data.column && sorting_data.order === 'DESC'" class="ml-2" src="@/assets/images/sort_desc.svg" alt="sort_desc">
        </span>
      </template>

      <template #table-busy>
        <b-spinner class="align-middle" :small="true"></b-spinner>
      </template>

      <template #cell(CreatedAt)="row">
        <p class="table-date">{{ row.value | date }}</p>
        <p class="table-time">{{ row.value | time }}</p>
      </template>

      <template #cell(file_name)="{ value, item }">
        <span
          class="cursor-pointer text-chai"
          @click="openDetail(item)"
        >
          {{ value }}
        </span>
      </template>

      <template #head(records)>
        <span v-b-tooltip.hover.bottom title="Total Parsed / Matched / Failed">
          Records <i class="mdi mdi-information-outline" style="font-size: 12px; opacity: 0.5;"></i>
        </span>
      </template>

      <template #cell(records)="{ item }">
        <span
          v-if="formatRecords(item)"
          v-b-tooltip.hover.bottom
          :title="`${item.total_records} Total txns parsed \u2022 ${item.total_success_records} Matched (amount match) \u2022 ${item.total_failed_records} Failed (missing/mismatch)`"
        >
          {{ formatRecords(item) }}
        </span>
        <span v-else>&mdash;</span>
      </template>

      <template #cell(status)="{ value }">
        <div
          class="badge custom-status"
          :class="{
            'badge-soft-success': value === 'FILE_UPLOAD_VALIDATION_SUCCESS',
            'badge-soft-danger': value === 'FILE_UPLOAD_VALIDATION_FAIL' || value === 'FILE_UPLOAD_INGESTION_FAIL',
            'badge-soft-secondary': value === 'FILE_UPLOAD_INITIATED',
            'badge-soft-warning': value === 'FILE_UPLOAD_PROCESSING',
          }"
        >
          <b-spinner
            v-if="value === 'FILE_UPLOAD_INITIATED' || value === 'FILE_UPLOAD_PROCESSING'"
            small
            class="mr-1"
          ></b-spinner>
          {{ statusText(value) }}
        </div>
      </template>

      <template #cell(actions)="{ item }">
        <b-dropdown class="show_details" size="sm p-0" variant="white bg-transparent" dropleft>
          <template v-slot:button-content>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M7.5 14.25C7.5 15.075 8.175 15.75 9 15.75C9.825 15.75 10.5 15.075 10.5 14.25C10.5 13.425 9.825 12.75 9 12.75C8.175 12.75 7.5 13.425 7.5 14.25ZM7.5 3.75C7.5 4.575 8.175 5.25 9 5.25C9.825 5.25 10.5 4.575 10.5 3.75C10.5 2.925 9.825 2.25 9 2.25C8.175 2.25 7.5 2.925 7.5 3.75ZM7.5 9C7.5 9.825 8.175 10.5 9 10.5C9.825 10.5 10.5 9.825 10.5 9C10.5 8.175 9.825 7.5 9 7.5C8.175 7.5 7.5 8.175 7.5 9Z" stroke="black" stroke-opacity="0.3"/>
            </svg>
          </template>
          <b-dropdown-item-button @click="openDetail(item)">View Details</b-dropdown-item-button>
          <b-dropdown-item-button v-if="item.file_path" @click="downloadFile(item)">Download File</b-dropdown-item-button>
        </b-dropdown>
      </template>
    </b-table>

    <div class="d-flex justify-content-between">
      <per-page
        v-model="perPage"
        :currentPage="currentPage"
        :totalRows="totalRows"
        :tableRowsCount="uploads.length"
        @input="onPerPageChange"
      />
      <b-pagination
        class="my-auto"
        v-model="currentPage"
        :current-page="currentPage"
        :total-rows="totalRows"
        :per-page="perPage"
        @input="fetchUploads"
      ></b-pagination>
    </div>

    <!-- Upload Drawer -->
    <div class="right-bar" :class="{ 'active': showDrawer }">
      <div data-simplebar class="h-100 d-flex flex-column">
        <div class="rightbar-title" style="padding: 25px;">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0" style="font-size: 16px; font-weight: 700;">Upload Files</h5>
            <i class="mdi mdi-close cursor-pointer" style="font-size: 20px; opacity: 0.5;" @click="closeDrawer"></i>
          </div>
          <p class="text-muted mb-0 mt-1" style="font-size: 14px;">Upload your reconciliation files</p>
        </div>
        <div class="border-sep"></div>

        <div class="flex-grow-1" style="padding: 25px;">
          <div class="form-group">
            <label style="font-size: 14px;">Data Source</label>
            <multiselect
              v-model="drawerDataSource"
              :options="dataSources"
              label="display_name"
              track-by="key"
              placeholder="Select data source"
              :allow-empty="false"
              class="custom-multiselect"
            />
          </div>

          <div class="form-group">
            <label style="font-size: 14px;">Files</label>
            <div
              class="upload-drop-area common-border text-center cursor-pointer"
              style="padding: 20px; border-style: dashed !important;"
              @click="$refs.fileInput.click()"
              @dragover.prevent
              @drop.prevent="onDrop"
            >
              <i class="mdi mdi-cloud-upload-outline" style="font-size: 32px; color: #DCDAD5;"></i>
              <p class="mb-0 mt-1" style="font-size: 14px; color: rgba(0,0,0,0.5);">
                Drop files here or <span class="text-chai">browse</span>
              </p>
              <p class="mb-0" style="font-size: 12px; color: rgba(0,0,0,0.3);">
                .xlsx, .xls, .csv, .txt (max 50MB)
              </p>
            </div>
            <input
              ref="fileInput"
              type="file"
              multiple
              accept=".xlsx,.xls,.csv,.txt"
              class="d-none"
              @change="onFilePicked"
            />
          </div>

          <div v-if="queuedFiles.length > 0" class="form-group">
            <label style="font-size: 14px;">Queued Files ({{ queuedFiles.length }})</label>
            <div
              v-for="(file, index) in queuedFiles"
              :key="index"
              class="d-flex justify-content-between align-items-center common-border mb-2"
              style="padding: 10px 16px;"
            >
              <div class="d-flex align-items-center" style="gap: 10px; min-width: 0;">
                <i class="mdi mdi-file-outline" style="font-size: 18px; opacity: 0.4;"></i>
                <div style="min-width: 0;">
                  <div class="text-truncate" style="max-width: 280px; font-size: 14px;">{{ file.name }}</div>
                  <div style="font-size: 12px; color: rgba(0,0,0,0.4);">{{ formatFileSize(file.size) }}</div>
                </div>
              </div>
              <i class="mdi mdi-close cursor-pointer" style="font-size: 16px; opacity: 0.4;" @click="removeFile(index)"></i>
            </div>
          </div>

          <div v-if="uploadResults.length > 0" class="form-group">
            <label style="font-size: 14px;">Upload Results</label>
            <div
              v-for="(result, index) in uploadResults"
              :key="'result-' + index"
              class="common-border mb-2"
              style="padding: 10px 16px;"
              :style="{
                borderColor: result.status === 'REJECTED' ? '#DE3535' : '#219653',
              }"
            >
              <div class="d-flex justify-content-between align-items-center">
                <div class="text-truncate" style="max-width: 280px; font-size: 14px;">{{ result.original_name }}</div>
                <div
                  class="badge custom-status ml-2 flex-shrink-0"
                  :class="{
                    'badge-soft-danger': result.status === 'REJECTED',
                    'badge-soft-success': result.status !== 'REJECTED',
                  }"
                >
                  {{ result.status === 'REJECTED' ? 'Rejected' : 'Accepted' }}
                </div>
              </div>
              <div v-if="result.mid" style="font-size: 12px; color: rgba(0,0,0,0.5); margin-top: 4px;">
                MID: {{ result.mid }}
              </div>
              <div v-if="result.error" style="font-size: 12px; color: #DE3535; margin-top: 4px;">
                {{ result.error }}
              </div>
            </div>
          </div>
        </div>

        <div class="border-sep"></div>
        <div class="d-flex justify-content-end" style="padding: 16px 25px; gap: 12px;">
          <b-btn variant="white" class="cancel" @click="closeDrawer">Cancel</b-btn>
          <b-btn
            variant="primary"
            :disabled="isUploading"
            @click="submitUpload"
            class="btn-padding"
          >
            <b-spinner v-if="isUploading" small class="mr-1"></b-spinner>
            Submit
          </b-btn>
        </div>
      </div>
    </div>
    <div class="rightbar-overlay" :class="{ 'active': showDrawer }" @click="closeDrawer"></div>

    <!-- Detail Sidebar -->
    <div class="right-bar detail-bar" :class="{ 'active': showDetailDrawer }">
      <div class="h-100 d-flex flex-column" style="overflow-y: auto;">
        <div style="padding: 25px;">
          <div class="d-flex justify-content-between align-items-center">
            <h5 class="mb-0" style="font-size: 16px; font-weight: 700;">Upload Details</h5>
            <i class="mdi mdi-close cursor-pointer" style="font-size: 20px; opacity: 0.5;" @click="closeDetail"></i>
          </div>
        </div>
        <div class="border-sep"></div>

        <div v-if="isLoadingDetail" class="text-center py-5">
          <b-spinner class="align-middle"></b-spinner>
        </div>

        <div v-else-if="detailItem" class="flex-grow-1" style="padding: 25px;">
          <div class="detail-row">
            <p class="detail-label">File Name</p>
            <p class="detail-value">{{ detailItem.file_name }}</p>
          </div>
          <div class="detail-row">
            <p class="detail-label">Data Source</p>
            <p class="detail-value">{{ detailItem.display_name }}</p>
          </div>
          <div class="detail-row">
            <p class="detail-label">Status</p>
            <p class="detail-value">
              <span
                class="badge custom-status"
                :class="{
                  'badge-soft-success': detailItem.status === 'FILE_UPLOAD_VALIDATION_SUCCESS',
                  'badge-soft-danger': detailItem.status === 'FILE_UPLOAD_VALIDATION_FAIL' || detailItem.status === 'FILE_UPLOAD_INGESTION_FAIL',
                  'badge-soft-secondary': detailItem.status === 'FILE_UPLOAD_INITIATED',
                  'badge-soft-warning': detailItem.status === 'FILE_UPLOAD_PROCESSING',
                }"
              >{{ statusText(detailItem.status) }}</span>
            </p>
          </div>
          <div class="detail-row">
            <p class="detail-label">Uploaded At</p>
            <p class="detail-value">{{ detailItem.CreatedAt | datetime }}</p>
          </div>
          <div class="detail-row">
            <p class="detail-label">Updated At</p>
            <p class="detail-value">{{ detailItem.UpdatedAt | datetime }}</p>
          </div>
          <div v-if="detailItem.metadata && detailItem.metadata.mid" class="detail-row">
            <p class="detail-label">MID</p>
            <p class="detail-value">{{ detailItem.metadata.mid }}</p>
          </div>
          <div v-if="detailItem.metadata && detailItem.metadata.provider" class="detail-row">
            <p class="detail-label">Provider</p>
            <p class="detail-value">{{ detailItem.metadata.provider }}</p>
          </div>
          <div v-if="detailItem.metadata && detailItem.metadata.recon_type" class="detail-row">
            <p class="detail-label">Recon Type</p>
            <p class="detail-value">{{ detailItem.metadata.recon_type }}</p>
          </div>
          <div class="detail-row">
            <p class="detail-label">Environment</p>
            <p class="detail-value">{{ detailItem.environment }}</p>
          </div>
          <div class="detail-row">
            <p class="detail-label">Ref</p>
            <p class="detail-value" style="word-break: break-all;">{{ detailItem.ref }}</p>
          </div>

          <div v-if="formatRecords(detailItem)">
            <div class="border-sep my-3"></div>
            <p class="detail-label mb-2" style="font-weight: 700;">Records</p>
            <div class="detail-row">
              <p class="detail-label">Total Parsed</p>
              <p class="detail-value">{{ detailItem.total_records }}</p>
            </div>
            <div class="detail-row">
              <p class="detail-label">Matched</p>
              <p class="detail-value">{{ detailItem.total_success_records }}</p>
            </div>
            <div class="detail-row">
              <p class="detail-label">Failed</p>
              <p class="detail-value">{{ detailItem.total_failed_records }}</p>
            </div>
          </div>

          <div v-if="detailItem.error">
            <div class="border-sep my-3"></div>
            <p class="detail-label mb-2" style="font-weight: 700;">Error</p>
            <div class="common-border p-3" style="background: rgba(222, 53, 53, 0.05); border-color: rgba(222, 53, 53, 0.2) !important;">
              <p class="mb-0 text-danger" style="font-size: 13px; word-break: break-word;">{{ detailItem.error }}</p>
            </div>
          </div>
        </div>

        <div v-if="detailItem && detailItem.file_path" class="mt-auto">
          <div class="border-sep"></div>
          <div class="d-flex justify-content-end" style="padding: 16px 25px; gap: 12px;">
            <b-btn variant="primary" class="btn-padding" @click="downloadFile(detailItem)">
              <i class="mdi mdi-download mr-1"></i> Download File
            </b-btn>
          </div>
        </div>
      </div>
    </div>
    <div class="rightbar-overlay" :class="{ 'active': showDetailDrawer }" @click="closeDetail"></div>
  </Layout>
</template>

<style scoped>
.right-bar {
  background-color: #fff;
  box-shadow: 0 0 24px 0 rgba(0, 0, 0, 0.06);
  position: fixed;
  transition: all 200ms ease-out;
  width: 420px;
  z-index: 9998;
  right: -430px;
  top: 0;
  bottom: 0;
}
.right-bar.active {
  right: 0;
}
.rightbar-overlay {
  background-color: rgba(0, 0, 0, 0.55);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: none;
  z-index: 9997;
  transition: all 0.2s ease-out;
}
.rightbar-overlay.active {
  display: block;
}
.border-sep {
  border-top: 1px solid #DCDAD5;
}
.upload-drop-area {
  transition: border-color 0.2s;
}
.upload-drop-area:hover {
  border-color: #FC6B2D !important;
}
::v-deep .custom-multiselect .multiselect__tags {
  border-radius: 12px;
  border: 1px solid #DCDAD5;
  min-height: 44px;
  padding: 0 15px;
}
.detail-bar {
  width: 440px;
  right: -450px;
}
.detail-bar.active {
  right: 0;
}
.detail-row {
  display: flex;
  justify-content: space-between;
  padding: 8px 0;
  border-bottom: 1px solid rgba(220, 218, 213, 0.3);
}
.detail-label {
  margin: 0;
  font-size: 13px;
  color: rgba(0, 0, 0, 0.5);
  flex-shrink: 0;
}
.detail-value {
  margin: 0;
  font-size: 14px;
  text-align: right;
  word-break: break-word;
}
@media (max-width: 575px) {
  .right-bar {
    width: 100%;
    right: -100%;
  }
  .detail-bar {
    width: 100%;
    right: -100%;
  }
}
</style>
